
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { utils_tool, component_tool, framework_tool } from '../../../../tool'
import { WizTableForm,WizDataAuthSelect } from '@/containers/common'
let { WizButton, WizCard, WizAntdForm, WizRow, WizCol } = component_tool
let { WizContainer } = framework_tool
class TypeAuthSelect extends Component {
    
  componentName = 'examAuthSelect';
  constructor(props) {
    super(props);
    this.state = {
    }
  }
  


  handleSubmit = e => {
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        let { submit } = this.props
        submit && submit(values)
      }
    });
  };


  /**
     * 重置表单
     */
    handleReset = () => {
        //重置表单
        this.props.form.resetFields();
      };
    
  render() {
    let { form,title,initialValue } = this.props
    return (
        <WizAntdForm onSubmit={this.handleSubmit}>
          {
            form.getFieldDecorator('dataAuth', { initialValue: Object.assign({}, initialValue) })(
              <WizDataAuthSelect/>
            )
          }
          <WizAntdForm.Item wrapperCol={{ span: 12, offset: 6 }}>
            <WizRow>
              <WizCol span={24} style={{ textAlign: 'center' }}>
                <WizButton type="primary" htmlType="submit">
                  保存
              </WizButton>
                <WizButton style={{ marginLeft: 20 }} onClick={this.handleReset}>
                  重置
              </WizButton>
              </WizCol>
            </WizRow>
          </WizAntdForm.Item>
        </WizAntdForm>

    )
  }

}

export default WizAntdForm.create()(TypeAuthSelect);

/**
 * 默认值
 */
TypeAuthSelect.defaultProps = {
    title: '数据权限选择',

}
/**
 * props入参校验
 */
TypeAuthSelect.propTypes = {
    title: PropTypes.string.isRequired,//卡片标题
    submit: PropTypes.fun,//提交的回调方法
}